(function () {
  'use strict';

  if (window.__petsoJdgmRatingRequiredInstalled) return;
  window.__petsoJdgmRatingRequiredInstalled = true;

  var FORM_SELECTOR = 'form.jdgm-form';
  var SCORE_SELECTOR = 'input[name="score"]';
  var RATING_SELECTOR = '.jdgm-form__rating, .jdgm-form-dynamic__rating';
  var SUBMIT_SELECTOR = '.jdgm-submit-rev, input[type="submit"]';
  var ERROR_CLASS = 'petso-jdgm-rating-error';
  var REQUIRED_CLASS = 'petso-jdgm-rating-required';
  var MESSAGE = 'Please select a star rating before submitting your review.';
  var errorSequence = 0;

  function addStyles() {
    if (document.getElementById('petso-jdgm-rating-required-styles')) return;

    var style = document.createElement('style');
    style.id = 'petso-jdgm-rating-required-styles';
    style.textContent =
      '.' + REQUIRED_CLASS + '{margin-left:.45rem;color:#a52a2a;font-size:.85em;font-weight:600;}' +
      '.' + ERROR_CLASS + '{display:block;margin:.55rem 0 0;color:#a52a2a;font-size:.95rem;font-weight:600;line-height:1.4;}' +
      '.jdgm-form__rating[aria-invalid="true"],.jdgm-form-dynamic__rating[aria-invalid="true"]{outline:2px solid #a52a2a;outline-offset:5px;border-radius:3px;}' +
      '@media(max-width:749px){.' + ERROR_CLASS + '{font-size:.9rem;}}';
    document.head.appendChild(style);
  }

  function getForm(target) {
    return target instanceof Element ? target.closest(FORM_SELECTOR) : null;
  }

  function getRatingGroup(form) {
    return form ? form.querySelector(RATING_SELECTOR) : null;
  }

  function getScoreInput(form) {
    return form ? form.querySelector(SCORE_SELECTOR) : null;
  }

  function hasValidScore(form) {
    var scoreInput = getScoreInput(form);
    if (!scoreInput) return true;
    var score = Number.parseInt(scoreInput.value, 10);
    return score >= 1 && score <= 5;
  }

  function findRatingLabel(form, ratingGroup) {
    var labels = form ? Array.prototype.slice.call(form.querySelectorAll('label')) : [];
    var matchingLabel = labels.find(function (label) {
      return (label.textContent || '').trim().toLowerCase().indexOf('rating') === 0;
    });
    return matchingLabel || (ratingGroup ? ratingGroup.previousElementSibling : null);
  }

  function markRatingRequired(form) {
    var ratingGroup = getRatingGroup(form);
    if (!ratingGroup) return;

    ratingGroup.setAttribute('aria-required', 'true');
    if (form.dataset.petsoJdgmRatingRequired === 'true') return;

    var label = findRatingLabel(form, ratingGroup);
    if (label && !label.querySelector('.' + REQUIRED_CLASS)) {
      var required = document.createElement('span');
      required.className = REQUIRED_CLASS;
      required.textContent = 'Required';
      required.setAttribute('aria-hidden', 'true');
      label.appendChild(required);
    }

    form.dataset.petsoJdgmRatingRequired = 'true';
  }

  function markAllForms() {
    Array.prototype.forEach.call(document.querySelectorAll(FORM_SELECTOR), markRatingRequired);
  }

  function scheduleFormMarking() {
    [0, 150, 500, 1200, 2500].forEach(function (delay) {
      window.setTimeout(markAllForms, delay);
    });
  }

  function clearError(form) {
    if (!form) return;
    var ratingGroup = getRatingGroup(form);
    var error = form.querySelector('.' + ERROR_CLASS);

    if (ratingGroup) {
      ratingGroup.removeAttribute('aria-invalid');
      ratingGroup.removeAttribute('aria-describedby');
    }
    if (error) error.remove();
  }

  function showError(form) {
    var ratingGroup = getRatingGroup(form);
    if (!ratingGroup) return;

    markRatingRequired(form);

    var error = form.querySelector('.' + ERROR_CLASS);
    if (!error) {
      errorSequence += 1;
      error = document.createElement('p');
      error.id = 'petso-jdgm-rating-error-' + errorSequence;
      error.className = ERROR_CLASS;
      error.setAttribute('role', 'alert');
      error.setAttribute('aria-live', 'assertive');
      error.textContent = MESSAGE;
      ratingGroup.insertAdjacentElement('afterend', error);
    }

    ratingGroup.setAttribute('aria-invalid', 'true');
    ratingGroup.setAttribute('aria-describedby', error.id);

    var firstStar = ratingGroup.querySelector('.jdgm-star[role="radio"], .jdgm-star');
    if (firstStar) {
      try {
        firstStar.focus({ preventScroll: true });
      } catch (error) {
        firstStar.focus();
      }
    }
    ratingGroup.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function blockMissingRating(event, form) {
    if (!form || hasValidScore(form)) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    showError(form);
    return true;
  }

  addStyles();
  scheduleFormMarking();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFormMarking, { once: true });
  }
  window.addEventListener('load', scheduleFormMarking, { once: true });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target instanceof HTMLFormElement && event.target.matches(FORM_SELECTOR) ? event.target : null;
      blockMissingRating(event, form);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target instanceof Element ? event.target : null;
      var submitControl = target ? target.closest(SUBMIT_SELECTOR) : null;
      var form = getForm(submitControl);
      if (submitControl && form) blockMissingRating(event, form);

      if (target && target.closest('.jdgm-write-rev-link')) scheduleFormMarking();

      var star = target ? target.closest('.jdgm-star') : null;
      var starForm = getForm(star);
      if (starForm) {
        window.setTimeout(function () {
          if (hasValidScore(starForm)) clearError(starForm);
        }, 0);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var form = getForm(event.target);
      if (form && hasValidScore(form)) clearError(form);
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (event) {
      var form = getForm(event.target);
      if (form) markRatingRequired(form);
    },
    true
  );
})();
